'use client';
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import DashboardTopbar from './DashboardTopbar';
import CopyrightFooter from './ui/CopyrightFooter';

interface AppLayoutProps {
  children: React.ReactNode;
  activeRoute?: string;
}

export default function AppLayout({ children, activeRoute }: AppLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'var(--background)' }}>
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        activeRoute={activeRoute}
      />
      <div
        className="flex flex-col flex-1 overflow-hidden transition-all duration-300"
        style={{ marginLeft: 0 }}
      >
        <DashboardTopbar />
        <main className="flex-1 overflow-y-auto scrollbar-thin px-6 py-6 xl:px-8 2xl:px-10">
          {children}
        </main>
        <CopyrightFooter variant="dark" />
      </div>
    </div>
  );
}